import {
    FormSection, IFormField
} from "../../shared/components/web-form/web-form.objects";

import {
    WebForm
} from "../../shared/components/web-form/web-form";

import {
    YesNoInputField,
    YesNoInputOptions
} from "../../shared/components/web-form/form-field/yes-no-input";
import {
    NumberInputField,
    NumberInputOptions
} from "../../shared/components/web-form/form-field/number-input";
import {
    DropdownInputField,
    DropdownInputOptions
} from "../../shared/components/web-form/form-field/dropdown-input";

import {
    TextInputField,
    TextInputOptions,
    TextInputType
} from "../../shared/components/web-form/form-field/text-input";

import {
    CabHubMonthlySurveyEntity,
    CabHubSurveyPageVm, 
} from "./cab-hub-tracking.entities";

function addSurveyInputAffixes(
    prefix:
        "cab" |
        "hub"
): void {

    const fields = [
        {
            fieldId:
                `${prefix}-survey-hours-worked`,
            suffix:
                "hours of consultation"
        },
        {
            fieldId:
                `${prefix}-survey-compensation-rate`,
            prefixText:
                "$",
            suffix:
                "/hr"
        }
    ];

    fields.forEach(
        field => {

            const $input =
                $(`#${field.fieldId}`);

            if (
                !$input.length ||
                $input.parent()
                    .hasClass("input-group")
            ) {
                return;
            }

            $input.wrap(
                `<div class="input-group"></div>`
            );

            if (field.prefixText) {
                $input.before(`
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            ${field.prefixText}
                        </span>
                    </div>
                `);
            }

            if (field.suffix) {
                $input.after(`
                    <div class="input-group-append">
                        <span class="input-group-text">
                            ${field.suffix}
                        </span>
                    </div>
                `);
            }
        }
    );
}
function markFieldInvalid(
    field:
        IFormField,
    isInvalid:
        boolean
): void {

    const $field =
        $(`#${field.fieldId}`);

    const $formGroup =
        $field.closest(
            ".form-group"
        );

    $formGroup
        .find(
            ".bootstrap-select"
        )
        .toggleClass(
            "is-invalid",
            isInvalid
        );
}
export class CabMonthlySurveyForm {
    private readonly metThisMonthField:
        YesNoInputField;

    private readonly notMetExplanationField:
        TextInputField;

    private readonly hoursWorkedField:
        NumberInputField;

    private readonly compensationRateField:
        NumberInputField;

    private readonly anticipatedHoursField:
        DropdownInputField;

    private readonly consultationTypesField:
        DropdownInputField;

    private readonly otherConsultationTypeField:
        TextInputField;

    private readonly workDescriptionField:
        TextInputField;

    private readonly satisfactionField:
        DropdownInputField;

    private readonly satisfactionExplanationField:
        TextInputField;

    private readonly supportRequestedField:
        YesNoInputField;

    private readonly supportExplanationField:
        TextInputField;

    private readonly trainingNeededField:
        DropdownInputField;

    private readonly trainingDescriptionField:
        TextInputField;

    private readonly webForm:
        WebForm;

    constructor(
        private readonly vm:
            CabHubSurveyPageVm
    ) {
        this.metThisMonthField =
            new YesNoInputField(
                "MetThisMonth",
                "cab-survey-met-this-month",
                "Did you meet with your Hub this month?",
                "",
                true,
                new YesNoInputOptions()
            );

        this.notMetExplanationField =
            new TextInputField(
                "NotMetExplanation",
                "cab-survey-not-met-explanation",
                "Why not?",
                "",
                false,
                this.textAreaOptions()
            );

        this.hoursWorkedField =
            new NumberInputField(
                "HoursWorked",
                "cab-survey-hours-worked",
                "How many hours did you work with your Hub this month?",
                "",
                true,
                new NumberInputOptions(
                    false,
                    0
                )
            );

        this.compensationRateField =
            new NumberInputField(
                "AdditionalHoursCompensationRate",
                "cab-survey-compensation-rate",
                "How much were you compensated for the additional hours worked (any number of hours >2 hours)?",
                "",
                false,
                new NumberInputOptions(
                    false,
                    0
                )
            );

        this.anticipatedHoursField =
            new DropdownInputField(
                "AnticipatedHoursNextMonthId",
                "cab-survey-anticipated-hours",
                "Do you anticipate working with your Hub for more than two hours next month?",
                "",
                true,
                new DropdownInputOptions(
                    "YesNoNotSure",
                    false,
                    false,
                    false
                )
            );

        this.consultationTypesField =
            new DropdownInputField(
                "ConsultationTypeIds",
                "cab-survey-consultation-types",
                "What type of consultation did you provide?",
                "",
                true,
                new DropdownInputOptions(
                    "CabConsultationType",
                    true,
                    true,
                    false
                )
            );

        this.otherConsultationTypeField =
            new TextInputField(
                "OtherConsultationType",
                "cab-survey-other-consultation-type",
                "Please explain.",
                "",
                false,
                this.textAreaOptions()
            );

        this.workDescriptionField =
            new TextInputField(
                "WorkDescription",
                "cab-survey-work-description",
                "Please describe what you worked on this month in 2–3 sentences.",
                "",
                true,
                this.textAreaOptions()
            );

        this.satisfactionField =
            new DropdownInputField(
                "SatisfactionRatingId",
                "cab-survey-satisfaction-rating",
                "How satisfied were you with your Hub partnership this month?",
                "",
                true,
                new DropdownInputOptions(
                    "SatisfactionRating",
                    false,
                    false,
                    false
                )
            );

        this.satisfactionExplanationField =
            new TextInputField(
                "SatisfactionExplanation",
                "cab-survey-satisfaction-explanation",
                "Can you tell us more about your answer to the previous question?",
                "",
                false,
                this.textAreaOptions()
            );

        this.supportRequestedField =
            new YesNoInputField(
                "SupportRequested",
                "cab-survey-support-requested",
                "Would you like to request support from the INTERACT team?",
                "",
                true,
                new YesNoInputOptions()
            );

        this.supportExplanationField =
            new TextInputField(
                "SupportRequestExplanation",
                "cab-survey-support-explanation",
                "Please explain.",
                "",
                false,
                this.textAreaOptions()
            );

        this.trainingNeededField =
            new DropdownInputField(
                "TrainingNeededId",
                "cab-survey-training-needed",
                "Based on what you’ve been working on, is there training that would be useful to support your future work?",
                "",
                true,
                new DropdownInputOptions(
                    "YesNoNotSure",
                    false,
                    false,
                    true
                )
            );

        this.trainingDescriptionField =
            new TextInputField(
                "TrainingDescription",
                "cab-survey-training-description",
                "What kind of training?",
                "",
                false,
                this.textAreaOptions()
            );

        this.webForm =
            new WebForm({
                formSections: [
                    new FormSection({
                        sectionId:
                            "cab-monthly-survey-questions",

                        displayName:
                            "",

                        formFields: [
                            this.metThisMonthField,
                            this.notMetExplanationField,
                            this.hoursWorkedField,
                            this.compensationRateField,
                            this.anticipatedHoursField,
                            this.consultationTypesField,
                            this.otherConsultationTypeField,
                            this.workDescriptionField,
                            this.satisfactionField,
                            this.satisfactionExplanationField,
                            this.supportRequestedField,
                            this.supportExplanationField,
                            this.trainingNeededField,
                            this.trainingDescriptionField
                        ]
                    })
                ],

                saveRoute:
                    window.location.pathname +
                    "?handler=SubmitCabSurvey",

                defaultItem:
                    this.getDefaultSurvey()
            });
    }

    public initialize():
        void {

        this.renderForm();

        this.webForm.currentItem =
            this.getDefaultSurvey();

        this.webForm.initialize(
            this.vm.PickLists ?? []
        );

        addSurveyInputAffixes(
            "cab"
        );

        this.initializeConditionalFields();
    }

    public async save():
        Promise<boolean> {

        let isValid =
            true;

        this.webForm
            .formSections
            .forEach(
                section => {

                    section.formFields
                        .forEach(
                            field => {

                                const fieldIsValid =
                                    field.checkValid();

                                if (!fieldIsValid) {
                                    field.displayValid(
                                        false
                                    );

                                    markFieldInvalid(
                                        field,
                                        true
                                    );
                                    isValid =
                                        false;
                                }
                                else {
                                    field.resetValidDisplay();

                                    markFieldInvalid(
                                        field,
                                        false
                                    );
                                }
                            }
                        );
                }
            );

        if (!isValid) {
            $("#cab-hub-survey-validation-message")
                .removeClass(
                    "d-none"
                );

            return false;
        }

        $("#cab-hub-survey-validation-message")
            .addClass(
                "d-none"
        );
        if (
            this.metThisMonthField
                .getValue() !== true
        ) {
            

            this.webForm.currentItem.AnticipatedHoursNextMonthId =
                0;

            this.webForm.currentItem.ConsultationTypeIds =
                "";

            this.webForm.currentItem.OtherConsultationType =
                "";

            this.webForm.currentItem.WorkDescription =
                "";
        }
        const result =
            await this.webForm
                .saveForm();

        if (!result) {
            this.webForm.isSaving =
                false;

            return false;
        }

        $("#cab-hub-survey-form-container")
            .html(`
        <div class="text-center py-5">
            <h4 class="mb-3">
                Survey Submitted
            </h4>

            <p class="mb-0">
                Your survey response was submitted successfully.
            </p>
        </div>
    `);

        return true;
    }

    private initializeConditionalFields():
        void {

        const updateMetFields =
            () => {

                const didMeet =
                    this.metThisMonthField
                        .getValue() === true;

                this.setFieldVisible(
                    this.notMetExplanationField,
                    !didMeet,
                    true
                );

                this.setFieldVisible(
                    this.hoursWorkedField,
                    didMeet,
                    true
                );

                this.setFieldVisible(
                    this.anticipatedHoursField,
                    didMeet,
                    true
                );

                this.setFieldVisible(
                    this.consultationTypesField,
                    didMeet,
                    true
                );

                this.setFieldVisible(
                    this.workDescriptionField,
                    didMeet,
                    true
                );

                if (didMeet) {
                    updateHoursField();
                    updateConsultationTypeField();
                }
                else {
                    this.setFieldVisible(
                        this.compensationRateField,
                        false
                    );

                    this.setFieldVisible(
                        this.otherConsultationTypeField,
                        false
                    );
                }
            };

        const updateHoursField =
            () => {

                const hours =
                    Number(
                        this.hoursWorkedField
                            .getValue() ?? 0
                    );

                this.setFieldVisible(
                    this.compensationRateField,
                    hours > 2,
                    true
                );
            };

        const updateConsultationTypeField =
            () => {

                const selected =
                    String(
                        this.consultationTypesField
                            .getValue() ?? ""
                    )
                        .split("|");

                const otherOption =
                    this.vm.PickLists
                        ?.find(
                            list =>
                                list.Id ===
                                "CabConsultationType"
                        )
                        ?.Json
                        ?.find(
                            item =>
                                item.Value
                                    .trim()
                                    .toLowerCase() ===
                                "other"
                        );

                const hasOther =
                    otherOption != null &&
                    selected.includes(
                        String(
                            otherOption.Id
                        )
                    );

                this.setFieldVisible(
                    this.otherConsultationTypeField,
                    hasOther,
                    true
                );
            };

        const updateSupportField =
            () => {

                const supportRequested =
                    this.supportRequestedField
                        .getValue() === true;

                this.setFieldVisible(
                    this.supportExplanationField,
                    supportRequested,
                    true
                );
            };

        const updateTrainingField =
            () => {

                const selectedId =
                    Number(
                        this.trainingNeededField
                            .getValue() ?? 0
                    );

                const yesOption =
                    this.vm.PickLists
                        ?.find(
                            list =>
                                list.Id ===
                                "YesNoNotSure"
                        )
                        ?.Json
                        ?.find(
                            item =>
                                item.Value
                                    .trim()
                                    .toLowerCase() ===
                                "yes"
                        );

                const trainingNeeded =
                    yesOption != null &&
                    selectedId ===
                    yesOption.Id;

                this.setFieldVisible(
                    this.trainingDescriptionField,
                    trainingNeeded,
                    true
                );
            };

        $("#cab-survey-met-this-month")
            .on(
                "form-field-change",
                updateMetFields
            );

        $("#cab-survey-hours-worked")
            .on(
                "form-field-change",
                updateHoursField
            );

        $("#cab-survey-consultation-types")
            .on(
                "form-field-change",
                updateConsultationTypeField
            );

        $("#cab-survey-support-requested")
            .on(
                "form-field-change",
                updateSupportField
            );

        $("#cab-survey-training-needed")
            .on(
                "form-field-change",
                updateTrainingField
            );
        this.setFieldVisible(
            this.notMetExplanationField,
            false
        );

        this.setFieldVisible(
            this.hoursWorkedField,
            false
        );

        this.setFieldVisible(
            this.compensationRateField,
            false
        );

        this.setFieldVisible(
            this.anticipatedHoursField,
            false
        );

        this.setFieldVisible(
            this.consultationTypesField,
            false
        );

        this.setFieldVisible(
            this.otherConsultationTypeField,
            false
        );

        this.setFieldVisible(
            this.workDescriptionField,
            false
        );
     
        updateSupportField();
        updateTrainingField();
    }

    private setFieldVisible(
        field:
            IFormField,
        isVisible:
            boolean,
        isRequired:
            boolean = false
    ): void {

        field.isRequired =
            isVisible &&
            isRequired;

        const $field =
            $(`#${field.fieldId}`);

        const $formGroup =
            $field.closest(
                ".form-group"
            );

        $formGroup
            .toggleClass(
                "d-none",
                !isVisible
            );

        $formGroup
            .find("label")
            .first()
            .toggleClass(
                "required",
                field.isRequired
            );

        if (!isVisible) {
            field.resetValidDisplay();

            markFieldInvalid(
                field,
                false
            );
        }
    }

    private getDefaultSurvey():
        CabHubMonthlySurveyEntity {

        return {
            Id:
                0,

            CabHubConnectionId:
                this.vm.ConnectionId,

            ReportingMonth:
                this.vm.ReportingMonth,

            ReportingYear:
                this.vm.ReportingYear,

            MetThisMonth:
                false,

            NotMetExplanation:
                "",

            HoursWorked:
                0,

            AdditionalHoursCompensationRate:
                null,

            AnticipatedHoursNextMonthId:
                0,

            ConsultationTypeIds:
                "",

            OtherConsultationType:
                "",

            WorkDescription:
                "",

            SatisfactionRatingId:
                0,

            SatisfactionExplanation:
                "",

            SupportRequested:
                false,

            SupportRequestExplanation:
                "",

            TrainingNeededId:
                0,

            TrainingDescription:
                ""
        };
    }

    private renderForm():
        void {

        $("#cab-hub-survey-modal-context")
            .text(
                `${this.vm.CabMemberName} | ${this.vm.HubShortName}`
            );

        $("#cab-hub-survey-modal-reporting-period")
            .text(
                this.getMonthDisplay()
            );

        let html =
            "";

        html += `
        <div id="cab-hub-survey-validation-message"
             class="alert alert-danger d-none"
             role="alert">
            Please fill in all required fields.
        </div>
    `;

        this.webForm
            .formSections
            .forEach(
                section => {

                    html += `
                    <section id="${section.sectionId}"
                             class="pt-0 pb-0">

                        <div class="form-row">
                `;

                    section.formFields
                        .forEach(
                            field => {

                                html += `
                                <div class="form-group col-12">
                                    ${field.generateHtml()}
                                </div>
                            `;
                            }
                        );

                    html += `
                        </div>
                   
                `;
                }
            );

        $("#cab-hub-survey-form")
            .empty()
            .html(
                html
            );
    }


    private getMonthDisplay():
        string {

        return new Date(
            this.vm.ReportingYear,
            this.vm.ReportingMonth - 1,
            1
        )
            .toLocaleDateString(
                "en-US",
                {
                    month:
                        "long",

                    year:
                        "numeric"
                }
            );
    }

    private textAreaOptions():
        TextInputOptions {

        return new TextInputOptions(
            TextInputType.Any,
            -99,
            -99,
            false,
            4
        );
    }
}


export class HubMonthlySurveyForm {
    private readonly metThisMonthField:
        YesNoInputField;

    private readonly notMetExplanationField:
        TextInputField;

    private readonly hoursWorkedField:
        NumberInputField;

    private readonly compensationRateField:
        NumberInputField;

    private readonly consultationTypesField:
        DropdownInputField;

    private readonly otherConsultationTypeField:
        TextInputField;

    private readonly workDescriptionField:
        TextInputField;

    private readonly satisfactionField:
        DropdownInputField;

    private readonly satisfactionExplanationField:
        TextInputField;
    private readonly anticipatedHoursField:
        DropdownInputField;

    private readonly supportRequestedField:
        YesNoInputField;

    private readonly supportExplanationField:
        TextInputField;

    private readonly trainingNeededField:
        DropdownInputField;

    private readonly trainingDescriptionField:
        TextInputField;

    private readonly webForm:
        WebForm;

    constructor(
        private readonly vm:
            CabHubSurveyPageVm
    ) {
        this.metThisMonthField =
            new YesNoInputField(
                "MetThisMonth",
                "hub-survey-met-this-month",
                `Did your team meet with ${vm.CabMemberName} this month?`,
                "",
                true,
                new YesNoInputOptions()
            );

        this.notMetExplanationField =
            new TextInputField(
                "NotMetExplanation",
                "hub-survey-not-met-explanation",
                "Why not?",
                "",
                false,
                this.textAreaOptions()
            );

       
        this.hoursWorkedField =
            new NumberInputField(
                "HoursWorked",
                "hub-survey-hours-worked",
                `How many hours of consultation did ${vm.CabMemberName} provide this month?`,
                "",
                true,
                new NumberInputOptions(
                    false,
                    0
                )
            );

        this.compensationRateField =
            new NumberInputField(
                "AdditionalHoursCompensationRate",
                "hub-survey-compensation-rate",
                "How much were they compensated for the additional hours worked (any number of hours >2 hours)?",
                "",
                false,
                new NumberInputOptions(
                    false,
                    0
                )
            );

        this.anticipatedHoursField =
            new DropdownInputField(
                "AnticipatedHoursNextMonthId",
                "hub-survey-anticipated-hours",
                `Do you anticipate working with ${vm.CabMemberName} for more than two hours next month?`,
                "",
                true,
                new DropdownInputOptions(
                    "YesNoNotSure",
                    false,
                    false,
                    false
                )
            );

        this.consultationTypesField =
            new DropdownInputField(
                "ConsultationTypeIds",
                "hub-survey-consultation-types",
                `What type of consultation did ${vm.CabMemberName} provide?`,
                "",
                true,
                new DropdownInputOptions(
                    "HubConsultationType",
                    true,
                    true,
                    false
                )
            );

        this.otherConsultationTypeField =
            new TextInputField(
                "OtherConsultationType",
                "hub-survey-other-consultation-type",
                "Please explain.",
                "",
                false,
                this.textAreaOptions()
            );

        this.workDescriptionField =
            new TextInputField(
                "WorkDescription",
                "hub-survey-work-description",
                `Please describe in 2–3 sentences what ${vm.CabMemberName} worked on this month.`,
                "",
                true,
                this.textAreaOptions()
            );

        this.satisfactionField =
            new DropdownInputField(
                "SatisfactionRatingId",
                "hub-survey-satisfaction-rating",
                "How satisfied were you with your partnership this month?",
                "",
                true,
                new DropdownInputOptions(
                    "SatisfactionRating",
                    false,
                    false,
                    false
                )
            );

        this.satisfactionExplanationField =
            new TextInputField(
                "SatisfactionExplanation",
                "hub-survey-satisfaction-explanation",
                "Can you tell us more about your answer to the previous question?",
                "",
                false,
                this.textAreaOptions()
            );

        this.supportRequestedField =
            new YesNoInputField(
                "SupportRequested",
                "hub-survey-support-requested",
                "Would you like to request support from the INTERACT team?",
                "",
                true,
                new YesNoInputOptions()
            );

        this.supportExplanationField =
            new TextInputField(
                "SupportRequestExplanation",
                "hub-survey-support-explanation",
                "Please explain.",
                "",
                false,
                this.textAreaOptions()
            );

        this.trainingNeededField =
            new DropdownInputField(
                "TrainingNeededId",
                "hub-survey-training-needed",
                `Based on your work with ${vm.CabMemberName} so far, is there training for ${vm.CabMemberName} or your team that would be useful to support future work?`,
                "",
                true,
                new DropdownInputOptions(
                    "YesNoNotSure",
                    false,
                    false,
                    false
                )
            );

        this.trainingDescriptionField =
            new TextInputField(
                "TrainingDescription",
                "hub-survey-training-description",
                "What kind of training?",
                "",
                false,
                this.textAreaOptions()
            );

        this.webForm =
            new WebForm({
                formSections: [
                    new FormSection({
                        sectionId:
                            "hub-monthly-survey-questions",

                        displayName:
                            "",

                        formFields: [
                            this.metThisMonthField,
                            this.notMetExplanationField,
                            this.hoursWorkedField,
                            this.compensationRateField,
                            this.anticipatedHoursField,
                            this.consultationTypesField,
                            this.otherConsultationTypeField,
                            this.workDescriptionField,
                            this.satisfactionField,
                            this.satisfactionExplanationField,
                            this.supportRequestedField,
                            this.supportExplanationField,
                            this.trainingNeededField,
                            this.trainingDescriptionField
                        ]
                    })
                ],

                saveRoute:
                    window.location.pathname +
                    "?handler=SubmitHubSurvey",

                defaultItem:
                    this.getDefaultSurvey()
            });
    }

    public initialize():
        void {

        this.renderForm();

        this.webForm.currentItem =
            this.getDefaultSurvey();

        this.webForm.initialize(
            this.vm.PickLists ?? []
        );

        addSurveyInputAffixes(
            "hub"
        );

        this.initializeConditionalFields();
    }

    public async save():
        Promise<boolean> {

        let isValid =
            true;

        this.webForm
            .formSections
            .forEach(
                section => {

                    section.formFields
                        .forEach(
                            field => {

                                const fieldIsValid =
                                    field.checkValid();

                                if (!fieldIsValid) {
                                    field.displayValid(
                                        false
                                    );
                                    markFieldInvalid(
                                        field,
                                        true
                                    );
                                    isValid =
                                        false;
                                }
                                else {
                                    field.resetValidDisplay();

                                    markFieldInvalid(
                                        field,
                                        false
                                    );
                                }
                            }
                        );
                }
        );

        var elementID = "cab-hub-survey-validation-message";

        if (!isValid) {
            $("#cab-hub-survey-validation-message")
                .removeClass("d-none");

            document
                .getElementById(elementID)
                ?.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });

            return false;
        }

        $("#cab-hub-survey-validation-message")
            .addClass(
                "d-none"
            );

        if (
            this.metThisMonthField
                .getValue() !== true
        ) {
           

            this.webForm.currentItem.AnticipatedHoursNextMonthId =
                0;

            this.webForm.currentItem.ConsultationTypeIds =
                "";

            this.webForm.currentItem.OtherConsultationType =
                "";

            this.webForm.currentItem.WorkDescription =
                "";
        }
        const result =
            await this.webForm
                .saveForm();

        if (!result) {
            this.webForm.isSaving =
                false;

            return false;
        }

        $("#cab-hub-survey-form-container")
            .html(`
        <div class="text-center py-5">
            <h4 class="mb-3">
                Survey Submitted
            </h4>

            <p class="mb-0">
                Your survey response was submitted successfully.
            </p>
        </div>
    `);

        return true;
    }

    private initializeConditionalFields():
        void {

        const updateMetFields =
            () => {

                const didMeet =
                    this.metThisMonthField
                        .getValue() === true;

                this.setFieldVisible(
                    this.notMetExplanationField,
                    !didMeet,
                    true
                );

                this.setFieldVisible(
                    this.hoursWorkedField,
                    didMeet,
                    true
                );

                this.setFieldVisible(
                    this.anticipatedHoursField,
                    didMeet,
                    true
                );

                this.setFieldVisible(
                    this.consultationTypesField,
                    didMeet,
                    true
                );

                this.setFieldVisible(
                    this.workDescriptionField,
                    didMeet,
                    true
                );

                if (didMeet) {
                    updateHoursField();
                    updateConsultationTypeField();
                }
                else {
                    this.setFieldVisible(
                        this.compensationRateField,
                        false
                    );

                    this.setFieldVisible(
                        this.otherConsultationTypeField,
                        false
                    );
                }
            };

        const updateHoursField =
            () => {

                const hours =
                    Number(
                        this.hoursWorkedField
                            .getValue() ?? 0
                    );

                this.setFieldVisible(
                    this.compensationRateField,
                    hours > 2,
                    true
                );
            };

        const updateConsultationTypeField =
            () => {

                const selected =
                    String(
                        this.consultationTypesField
                            .getValue() ?? ""
                    )
                        .split("|");

                const otherOption =
                    this.vm.PickLists
                        ?.find(
                            list =>
                                list.Id ===
                                "HubConsultationType"
                        )
                        ?.Json
                        ?.find(
                            item =>
                                item.Value
                                    .trim()
                                    .toLowerCase() ===
                                "other"
                        );

                const hasOther =
                    otherOption != null &&
                    selected.includes(
                        String(
                            otherOption.Id
                        )
                    );

                this.setFieldVisible(
                    this.otherConsultationTypeField,
                    hasOther,
                    true
                );
            };

        const updateSupportField =
            () => {

                const supportRequested =
                    this.supportRequestedField
                        .getValue() === true;

                this.setFieldVisible(
                    this.supportExplanationField,
                    supportRequested,
                    true
                );
            };

        const updateTrainingField =
            () => {

                const selectedId =
                    Number(
                        this.trainingNeededField
                            .getValue() ?? 0
                    );

                const yesOption =
                    this.vm.PickLists
                        ?.find(
                            list =>
                                list.Id ===
                                "YesNoNotSure"
                        )
                        ?.Json
                        ?.find(
                            item =>
                                item.Value
                                    .trim()
                                    .toLowerCase() ===
                                "yes"
                        );

                const trainingNeeded =
                    yesOption != null &&
                    selectedId ===
                    yesOption.Id;

                this.setFieldVisible(
                    this.trainingDescriptionField,
                    trainingNeeded,
                    true
                );
            };

        $("#hub-survey-met-this-month")
            .on(
                "form-field-change",
                updateMetFields
            );

        $("#hub-survey-hours-worked")
            .on(
                "form-field-change",
                updateHoursField
            );

        $("#hub-survey-consultation-types")
            .on(
                "form-field-change",
                updateConsultationTypeField
            );

        $("#hub-survey-support-requested")
            .on(
                "form-field-change",
                updateSupportField
            );

        $("#hub-survey-training-needed")
            .on(
                "form-field-change",
                updateTrainingField
            );

        this.setFieldVisible(
            this.notMetExplanationField,
            false
        );

        this.setFieldVisible(
            this.hoursWorkedField,
            false
        );

        this.setFieldVisible(
            this.compensationRateField,
            false
        );

        this.setFieldVisible(
            this.anticipatedHoursField,
            false
        );

        this.setFieldVisible(
            this.consultationTypesField,
            false
        );

        this.setFieldVisible(
            this.otherConsultationTypeField,
            false
        );

        this.setFieldVisible(
            this.workDescriptionField,
            false
        );
        updateSupportField();
        updateTrainingField();
    }

    private setFieldVisible(
        field:
            IFormField,
        isVisible:
            boolean,
        isRequired:
            boolean = false
    ): void {

        field.isRequired =
            isVisible &&
            isRequired;

        const $field =
            $(`#${field.fieldId}`);

        const $formGroup =
            $field.closest(
                ".form-group"
            );

        $formGroup
            .toggleClass(
                "d-none",
                !isVisible
            );

        $formGroup
            .find("label")
            .first()
            .toggleClass(
                "required",
                field.isRequired
            );

        if (!isVisible) {
            field.resetValidDisplay();

            markFieldInvalid(
                field,
                false
            );
        }
    }

    private getDefaultSurvey():
        CabHubMonthlySurveyEntity {

        return {
            Id:
                0,

            CabHubConnectionId:
                this.vm.ConnectionId,

            ReportingMonth:
                this.vm.ReportingMonth,

            ReportingYear:
                this.vm.ReportingYear,

            MetThisMonth:
                false,

            NotMetExplanation:
                "",

            HoursWorked:
                0,

            AdditionalHoursCompensationRate:
                null,

            AnticipatedHoursNextMonthId:
                0,

            ConsultationTypeIds:
                "",

            OtherConsultationType:
                "",

            WorkDescription:
                "",

            SatisfactionRatingId:
                0,

            SatisfactionExplanation:
                "",

            SupportRequested:
                false,

            SupportRequestExplanation:
                "",

            TrainingNeededId:
                0,

            TrainingDescription:
                ""
        };
    }

    private renderForm():
        void {

        $("#cab-hub-survey-modal-context")
            .text(
                `${this.vm.RespondentName} | ${this.vm.HubShortName}`
            );

        $("#cab-hub-survey-modal-reporting-period")
            .text(
                this.getMonthDisplay()
            );
        let html =
            "";
        html += `
                    <div id="cab-hub-survey-validation-message"
                         class="alert alert-danger d-none col-12 pl-3"
                         role="alert">
                        Please fill in all required fields.
                    </div>

                    </div>
                    
                `;

        this.webForm
            .formSections
            .forEach(
                section => {

                    html += `
                    <section id="${section.sectionId}"
                             class="pt-0 pb-0">

                        <div class="form-row">
                `;

                    section.formFields
                        .forEach(
                            field => {

                                html += `
                                <div class="form-group col-12">
                                    ${field.generateHtml()}
                                </div>
                            `;
                            }
                        );

                    html += `
                        </div>
                   
                `;
                }
            );

        $("#cab-hub-survey-form")
            .empty()
            .html(
                html
            );
    }

    private getMonthDisplay():
        string {

        return new Date(
            this.vm.ReportingYear,
            this.vm.ReportingMonth - 1,
            1
        )
            .toLocaleDateString(
                "en-US",
                {
                    month:
                        "long",

                    year:
                        "numeric"
                }
            );
    }

   
    private textAreaOptions():
        TextInputOptions {

        return new TextInputOptions(
            TextInputType.Any,
            -99,
            -99,
            false,
            4
        );
    }
}